module.exports = "pegasus_template/assets/hexagon-pinterest.gif";